import * as Common from "../../commons/common"
import moment from 'moment'

export class Examinee {
  id: number
  sheet_id: number
  seqNo: number
  student_no: number
  student_code: string
  student_name: string
  times: number
  result_image_created: boolean
  review_image_created: boolean
  submitted_at: string
  submitted_at_plane_text: Date
  student_sheet_id: number
  status: number
  scored_user_name: string
  score: number
  saitenCompletedFieldCount: number
  checked: boolean = false
  sheetActivities: SheetActivity[] = new Array<SheetActivity>()
  fieldActivities: FieldActivity[] = new Array<FieldActivity>()
  base64ScanImages: string[] = new Array<string>();
  base64ResultImages: string[] = new Array<string>();
  base64ReviewImages: string[] = new Array<string>();
  saitenCompleted: boolean;
  isSaitenTarget: boolean = true;
  isFailure: boolean = false;
  is_publish: boolean | null = null
  is_publish_cache: boolean | null = null
  isDownloadTarget: boolean = false

  constructor(examinee: any, sheetActivities: SheetActivity[], fieldActivities: FieldActivity[], no: number, saitenTargetExamineeIds: number[], sheet_type: number, isExamManualPublishActive: boolean){
    this.id = examinee.id;
    this.sheet_id = examinee.sheet_id;
    this.seqNo = no;
    this.student_no = examinee.student_no;
    this.student_code = examinee.student_code;
    this.student_name = examinee.student_name;
    this.times = examinee.times;
    this.result_image_created = examinee.result_image_created;
    this.review_image_created = examinee.review_image_created;
    this.submitted_at = examinee.submitted_at ? moment(examinee.submitted_at).format('Y年M月D日') : "-";
    this.submitted_at_plane_text = examinee.submitted_at;
    this.student_sheet_id = examinee.student_sheet_id;
    this.status = examinee.status;
    this.scored_user_name = examinee.scored_user_name;
    this.sheetActivities = sheetActivities.filter(x => x.student_id == this.student_no);
    this.sheetActivities.forEach(x => {
      this.fieldActivities = this.fieldActivities.concat(fieldActivities.filter(y => y.sheet_activity_id == x.id));
    });
    this.saitenCompletedFieldCount = this.fieldActivities.filter(x => x.saiten_completed).length;
    this.score = Common.sumArray(this.fieldActivities.map(x => x.score == null ? 0 : x.score));
    this.saitenCompleted = this.sheetActivities.filter(x => !x.saiten_completed).length == 0;
    this.isSaitenTarget = saitenTargetExamineeIds.length == 0 ? !this.saitenCompleted : saitenTargetExamineeIds.includes(this.id);
    if(sheet_type == Common.SheetTypeEnum.Report && this.result_image_created && this.review_image_created){
      this.is_publish = this.status >= Common.StudentSheetStatusEnum.Failure;
      this.is_publish_cache = this.status >= Common.StudentSheetStatusEnum.Failure;
    }else if(sheet_type == Common.SheetTypeEnum.LessonTest && this.result_image_created){
      this.is_publish = this.status >= Common.StudentSheetStatusEnum.Failure;
      this.is_publish_cache = this.status >= Common.StudentSheetStatusEnum.Failure;
    }else if(Common.isApprovalExamSheetType(sheet_type) && isExamManualPublishActive && this.result_image_created && this.review_image_created){
      this.is_publish = this.status >= Common.StudentSheetStatusEnum.Failure;
      this.is_publish_cache = this.status >= Common.StudentSheetStatusEnum.Failure;
    }
  }
}

const createReviewText = (x: any, idx: number) => {
  const rtn = new ReviewText();
  rtn.id = x.id;
  rtn.idx = x.idx;
  rtn.sheet_activity_id = x.sheet_activity_id;
  rtn.font_size = x.font_size;
  rtn.line_height = x.line_height;
  rtn.text = rtn.text;
  rtn.x = x.x;
  rtn.y = x.y;
  rtn.width = x.width;
  rtn.height = x.height;
  return rtn;
}

export class SheetActivity {
  id: number
  student_id: number
  score: number
  saiten_completed: boolean
  page: number
  reviewTexts: ReviewText[] = new Array<ReviewText>()
  reviewImages: ReviewImage[] = new Array<ReviewImage>()
  idx: number = 0
  base64Canvas: string
  is_canvas_drawed: boolean = false

  constructor(sheetActivity: any){
    this.id = sheetActivity.id;
    this.student_id = sheetActivity.student_id;
    this.score = sheetActivity.score;
    this.saiten_completed = sheetActivity.saiten_completed;
    this.page = sheetActivity.page;
  }
}

export class FieldActivity {
  id: number
  sheet_activity_id: number
  sheet_field_id: number
  score: number
  correct_state: number
  saiten_completed: boolean
  
  constructor(fieldActiviby: any){
    this.id = fieldActiviby.id;
    this.sheet_activity_id = fieldActiviby.sheet_activity_id;
    this.sheet_field_id = fieldActiviby.sheet_field_id;
    this.score = fieldActiviby.score;
    this.correct_state = fieldActiviby.correct_state;
    this.saiten_completed = fieldActiviby.saiten_completed;
  }
}

export class ReviewText {
  id: number
  sheet_activity_id: number
  idx: number
  direction: number
  text: string = null
  color: string = null
  font_size: number = null
  line_height: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  base64_text: string = null
  is_active: boolean = false
  review_type: number = null
}

export class ReviewImage {
  id: number
  sheet_activity_id: number
  idx: number
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  base64_image: string = null
  is_active: boolean = false
  review_type: number = null
}

export class Sheet {
  base_sheet_id: number
  name: string
  allot: number
  page_count: number
  course_code: string
  campus_code: string
  class_code: string
  imageWidth: number
  imageHeight: number
  passing_score: number

  constructor(sheet: any){
    this.base_sheet_id = sheet.base_sheet_id;
    this.name = sheet.name;
    this.allot = sheet.allot;
    this.page_count = sheet.page_count;
    this.course_code = sheet.course_code;
    this.campus_code = sheet.campus_code;
    this.class_code = sheet.class_code;
    this.imageWidth = sheet.correct_image_size[0];
    this.imageHeight = sheet.correct_image_size[1];
    this.passing_score = sheet.passing_score;
  }
}

export class SheetField {
  id: number
  part1: string
  part2: string
  part3: string
  allot: number
  allotCache: number
  scoreAverage: number
  scoreRate: number
  FieldActivities: FieldActivity[] = new Array<FieldActivity>()
  isSaitenCompleted: boolean
  saitenCompletedCount: number
  scoring_type: number

  constructor(sheetField: any, fieldActivities: FieldActivity[]){
    this.id = sheetField.id;
    this.part1 = sheetField.part1;
    this.part2 = sheetField.part2;
    this.part3 = sheetField.part3;
    this.allot = sheetField.allot;
    this.allotCache = sheetField.allot;
    this.FieldActivities = fieldActivities.filter(x => x.sheet_field_id == this.id);
    const totalScore: number = Common.sumArray(this.FieldActivities.map(x => x.score == null ? 0 : x.score));
    this.scoreAverage = Number((totalScore / this.FieldActivities.length).toFixed(1));
    this.scoreRate = Math.round(totalScore / (this.allot * this.FieldActivities.length) * 100);
    this.isSaitenCompleted = this.FieldActivities.filter(x => !x.saiten_completed).length == 0;
    this.saitenCompletedCount = this.FieldActivities.filter(x => x.saiten_completed).length;
    this.scoring_type = sheetField.scoring_type;
  }
}

export class ScoreOption {
  value: number
  text: string

  constructor(value: number, text: string){
    this.value = value;
    this.text = text;
  }
}

export class SearchCondition {
  student_code: string = ""
  student_name: string = ""
  times: string = ""
  saiten_completed: string = ""
  review_completed: string = ""
  published: string = ""
  submitted_at_from: string = ""
  submitted_at_to: string = ""
  score_from: string = ""
  score_to: string = ""
}

export const ModalImageKindEnum = Object.freeze({Scan: 1, Result: 2});

export enum ReviewTypeEnum {
  Text = 1,
  Image = 2,
}

export enum AutoReviewTargetTypeEnum {
  TotalScore = 1,
  Part1 = 2,
}

export class AutoReviewTextTemplate {
  id: number
  // 採点画面では旧データも混在しうるため、受信直後は null を許容する
  target_type: number | null = null
  part1: string | null = null
  score_from: number | null = null
  score_to: number | null = null
  page: number
  text: string = null
  color: string = null
  font_size: number = null
  line_height: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  direction: number
  base64_text: string = null
}

export class AutoReviewImageTemplate {
  id: number
  // 採点画面では旧データも混在しうるため、受信直後は null を許容する
  target_type: number | null = null
  part1: string | null = null
  score_from: number | null = null
  score_to: number | null = null
  page: number
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  base64_image: string = null
}
